import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ReisekostenabrechnungenService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ReisekostenabrechnungenService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ReisekostenabrechnungenServiceModule {}
